import React from 'react';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import styles from './index.module.scss';

type Props = {
  title: string;
  pickUpCompleted: string;
  answerFromOrder: string;
  answerAfterPaid: string;
  closeModal: () => void;
};

export const Presenter: React.FC<Props> = ({
  title,
  pickUpCompleted,
  answerFromOrder,
  answerAfterPaid,
  closeModal,
}) => (
  <CommonModal title={title} closeModal={closeModal}>
    <div className={styles.title}>■{pickUpCompleted}</div>
    <div>・{answerFromOrder}</div>
    <div>・{answerAfterPaid}</div>
  </CommonModal>
);
